import compress from 'graphql-query-compress';
import session from '@/services/session';
export { default as genericCreate } from './generic-create';
export { default as genericFind } from './generic-find';
export { default as genericGet } from './generic-get';
export { default as genericRemove } from './generic-remove';

// NOTE: circular dependency on auth and user modules
// so session keys should match those found in those modules

export default <ResponseType>(rawQuery: string) => {
  const query = compress(rawQuery);
  return (payload: any = {}) => (
    fetch('/gql', {
      body: JSON.stringify({
        payload,
        query,
      }),
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'x-pleatt-token': session.get('t:v') || '',
      },
    })
    .then(response => (
      // parse JSON response
      response.json().then(res => {
        // redirect when auth token invalid
        if (res && res.code === 'AUTH_TOKEN_INVALID') {
          session.clear('t:e'); // token expiry
          session.clear('t:v'); // token value
          session.clear('u');   // user
          const redirect = `${location.pathname}${location.search}`;
          location.href = `/?r=${redirect}`;
        }

        // reject if status not valid
        return response.status >= 200 && response.status < 300
          ? res as ResponseType
          : Promise.reject(res);
      })
    ))
  );
};
